import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function deleteRow(timesheetId: string) {
	const response = await fetch(`${apiEndpoint}/timesheet/${timesheetId}`, {
		method: 'DELETE',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return null;
}